import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';

import { Redirect } from 'react-router';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import axios from 'axios/index';
import ItemAdder from "main/content/sales/billing/itemAdder";
import { Button, Checkbox, FormControlLabel, InputLabel, Select as MSelect, MenuItem, Radio, TextField, Tooltip } from 'material-ui';
import {
    DialogActions
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';

import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const CREDIT_SALES_LEDGER_ID = '2';
const SALES_ACCOUNT_LEDGER_ID = '1';
const SALES_TAX_PAYABLE_VAT_LEDGER_ID = '11';
const SALES_TAX_PAYABLE_NBT_LEDGER_ID = '7';

const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});


class Billing extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTaxOption: '',
            loading: false,
            billDate: new Date(),

            isQuotation: false,
            isProformaInvoice: false,
            referenceNumber: '',
            invoiceJobNumbers: [],
            invoiceJobNumber: null,
            quotationNumbers: [],
            quotationNumber: '',

            selectedTaxOption: 'tax_invoice',

            customerVatNumber: '',

            customerTypes: [],
            customerType: 'All',
            customerCodes: [],
            customerCode: '',
            customerNames: [],
            customerName: null,
            customerPrivilageDiscount: null,
            customers: [],
            customerTypes2: [],
            customerType2: 'All',
            refParser: '',

            borkerList: [],
            broker: '',
            jobList: [],
            job: '',

            salesman: {
                salesmanList: [],
                salesman: null
            },

            paymentTerm: 'select_payment_term',

            latePaymentCharge: 'dont_charge',
            latePaymentMonthlyCharge: '0',
            isLatePaymentChargePercentage: false,

            paymentTermByDays: '',
            //paymentTermByNetDate: null,
            paymentNetDate: undefined,

            records: [],
            selectedItems: [],
            sumValues: {},
            rediret: false,
            redirectToNewBroker: false
        };


        this.populateFileds();

        this.handleBillDateChange = this.handleBillDateChange.bind(this);
        //this.handlePaymentDateChange = this.handlePaymentDateChange.bind(this);

        this.handlePaymnetDayChange = this.handlePaymnetDayChange.bind(this);
        this.alertFunction = this.alertFunction.bind(this);
        this.getItemAdderState = this.getItemAdderState.bind(this);


    }

    alertFunction(message, type) {
        if (type == 'success') {
            this.props.alert.success(message);
        } else {
            this.props.alert.error(message);
        }
    }

    handleBillDateChange(date) {
        //console.log('changeDate', date);
        this.setState({ billDate: date });
    }

    handlePaymnetDayChange(day) {
        this.setState({ paymentNetDate: day });
    }



    /* handlePaymentDateChange(date) {
        //console.log('changeDate',date);
        this.setState({
            paymentTermByNetDate: date
        });
    } */
    getJobsByCustomer() {
        let jobList = [];
        let toCompare = this.state.customerCode.value ? this.state.customerCode.value : this.state.customerCode;
        //console.log('getJobsByCustomer this.state.customerCode',this.state.customerCode);
        // console.log('toCompare',toCompare);
        if (this.state.customerCode == '') {
            return this.state.jobList;
        }
        else {
            for (let i = 0; i < this.state.jobList.length; i++) {
                // console.log('this.state.jobList.length',this.state.jobList.length );
                // console.log('joblist comparing by customer',String(this.state.jobList[i].customerId),String(toCompare)  );
                if (String(this.state.jobList[i].customerId) == String(toCompare)) {
                    jobList.push(this.state.jobList[i]);
                }
                if (i == this.state.jobList.length - 1) {
                    return jobList;
                }
            }
        }

    }

    customersByCustomerType() {

        let customerCodes = [];
        let customerNames = [];

        for (let i = 0; i < this.state.customers.length; i++) {
            if (this.state.customerType == 'All') {
                customerCodes.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_CODE });
                customerNames.push({
                    value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name + ' ' + this.state.customers[i].CUSTOMER_PROFILE.cx_billing_address_city, tooTip: this.state.customers[i].CUSTOMER_PROFILE.CURRENT_ADDRESS
                });
            }
            else if (this.state.customerType == this.state.customers[i].CUSTOMER_PROFILE.cx_type) {
                customerCodes.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_CODE });
                customerNames.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name + ' ' + this.state.customers[i].CUSTOMER_PROFILE.cx_billing_address_city, toolTip: this.state.customers[i].CUSTOMER_PROFILE.CURRENT_ADDRESS });
            }

        }

        var c = { customerCodes: customerCodes, customerNames: customerNames };

        return c;
    }

    handleJobChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ job: selectedOption.value });

            // this.setState({ loading: true });
            let body = {
                id: selectedOption.value
            };
            var url = window.crmServer + "/job/invoiceData";
            const request = axios.post(url, body);

            request.then((response) => {
                if (response.data) {
                    console.log('Job Services', response.data);
                }

                var customerOfJoB;
                for (let i = 0; i < this.state.jobList.length; i++) {
                    if (this.state.jobList[i].value == selectedOption.value) {
                        customerOfJoB = this.state.jobList[i].customerId;
                        break;
                    }
                }

                this.handleCusCodeChange({ value: customerOfJoB });


                let body2 = {
                    id: customerOfJoB
                };
                var url2 = window.crmServer + "/crm/getCustomer/byId";
                const request2 = axios.post(url2, body2);
                request2.then((response2) => {
                    if (response2.data) {
                        console.log('Customer of Job Details', response2.data);
                    }
                    var customerType;
                    if (window.env === "IMC") {
                        customerType = response2.data.result[0].CUSTOMER_PROFILE.cx_type;
                    } else {
                        customerType = response2.data[0].CUSTOMER_PROFILE.cx_type;
                    }
                    var serviceItemIds = [];
                    var serviceItems = [];
                    for (let c = 0; c < response.data.length; c++) {
                        serviceItemIds.push(response.data[c].SUB_TASK_INSTRUMENT_ID);
                    }
                    let body3 = {
                        ids: serviceItemIds
                    };
                    var url3 = window.inventoryServer + "/inventory/get/servicesByServiceIdList";
                    const request3 = axios.post(url3, body3);

                    request3.then((response3) => {
                        if (!response3.data.error && response3.data.success == true) {
                            console.log('service item info', response3.data.services);

                            let serviceInfo = {};
                            for (let x = 0; x < response3.data.services.length; x++) {
                                serviceInfo[response3.data.services[x].ID_ITEM] =
                                {
                                    name: response3.data.services[x].GENERAL_NAME,
                                    retailPrice: response3.data.services[x].RETAIL_PRICE,
                                    wholesalePrice: response3.data.services[x].WHOLESALE_PRICE,
                                }
                            }

                            // console.log('serviceInfo', serviceInfo);

                            let invoiceDataList = response.data;
                            let recordList = [];
                            for (let x = 0; x < invoiceDataList.length; x++) {

                                let itemId = invoiceDataList[x].SUB_TASK_INSTRUMENT_ID;
                                let itemQuantity = invoiceDataList[x].COUNT;
                                let unitPrice = customerType == 'Retail' ? serviceInfo[itemId].retailPrice : serviceInfo[itemId].wholesalePrice;
                                let itemRow = {
                                    itemCode: itemId, itemName: serviceInfo[itemId].name, isService: 1, quantity: itemQuantity,
                                    unitPrice: unitPrice, discount: 0.00, isDiscountPercentage: false,
                                    netPrice: (parseFloat(unitPrice) * parseFloat(itemQuantity)).toFixed(2)
                                };
                                recordList.push(itemRow);
                            }

                            this.setState({ records: recordList }, () => {
                                console.log('records from state', this.state.records);
                            });


                        } else {
                            console.log('response success false', response3);
                        }

                        this.setState({ loading: false });

                    })
                        .catch((error) => {
                            if (error && error != undefined) {
                                console.log('servicesByServiceIdList error', error);
                            }
                            this.setState({ loading: false });

                        });



                })


                    .catch(error => {
                        if (error && error != undefined) {
                            console.log('getCustomer/byId error', error);
                        }
                        this.setState({ loading: false });
                    });


                this.setState({ loading: false });

            })
                .catch((error) => {
                    if (error && error != undefined) {
                        console.log('invoiceData error', error);
                    }
                    this.setState({ loading: false });

                });




        }
        else {
            this.setState({ job: '' });
        }
    }

    handleQuotationChange = (selectedOption) => {
        this.setState(
            {
                quotationNumber: selectedOption,
                job: ''
            }
        );

        if (selectedOption) {
            this.setState({ loading: true });

            let body = {
                id: selectedOption.value
            };
            var url = window.salesServer + "/quotation/getQuotationById";
            const request = axios.post(url, body);

            request.then((response) => {

                if (!response.data.error && response.data.success) {
                    console.log('quotation data recieved', response.data);

                    var date = moment(response.data.quotation[0].BILL_DATE);

                    //console.log('this.state.customers',this.state.customers);
                    for (let i = 0; i < this.state.customers.length; i++) {
                        //console.log('compare', this.state.customers[i].CUSTOMER_CODE, parseInt(response.data.quotation[0].CUSTOMER_ID));
                        if (String(this.state.customers[i].CUSTOMER_CODE) === String(response.data.quotation[0].CUSTOMER_CODE)) {
                            //console.log('cx name match', this.state.customers[i].CUSTOMER_PROFILE.cx_name, this.state.customers[i].CUSTOMER_CODE, response.data.quotation[0].CUSTOMER_ID);
                            this.setState({
                                customerName: { value: response.data.quotation[0].CUSTOMER_ID, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name },
                                customerCode: { value: response.data.quotation[0].CUSTOMER_ID, label: this.state.customers[i].CUSTOMER_CODE }
                            }
                                ,
                                () => {
                                    console.log('after qutation change :: ', this.state.customerCode);
                                });
                            break;
                        }
                        else if (i == this.state.customers.length - 1) {
                            this.setState({ customerName: '' });
                            this.setState({ customerCode: '' });
                        }
                    }

                    for (let i = 0; i < this.state.borkerList.length; i++) {
                        //console.log('compare', this.state.customers[0].CUSTOMER_CODE, parseInt(response.data.quotation[0].CUSTOMER_ID));
                        if (this.state.borkerList[i].value == parseInt(response.data.quotation[0].ID_SALES_BROKER)) {
                            //console.log('cx name match', this.state.customers[i].CUSTOMER_PROFILE.cx_name);
                            this.setState({ broker: { value: this.state.borkerList[i].value, label: this.state.borkerList[i].label } });
                            break;
                        }
                        else if (i == this.state.borkerList.length - 1) {
                            this.setState({ broker: null });
                        }
                    }

                    if (response.data.quotation[0].PAYMENT_TERM_NET) {
                        console.log('PAYMENT_TERM_NET');
                        this.setState({
                            paymentNetDate: new Date(response.data.quotation[0].PAYMENT_TERM_NET),
                            paymentTermByDays: '',
                            paymentTerm: 'net'
                        });
                    } else if (response.data.quotation[0].PAYMENT_TERM_BY) {
                        console.log('PAYMENT_TERM_BY');
                        this.setState({
                            paymentNetDate: undefined,
                            paymentTermByDays: response.data.quotation[0].PAYMENT_TERM_BY,
                            paymentTerm: 'by'
                        });
                    } else {
                        this.setState({
                            paymentNetDate: undefined,
                            paymentTermByDays: '',
                            paymentTerm: 'select_payment_term'
                        });
                    }

                    if (response.data.quotation[0].LATE_PAYMENT_CHARGE) {
                        this.setState({
                            latePaymentMonthlyCharge: response.data.quotation[0].LATE_PAYMENT_CHARGE,
                            latePaymentCharge: 'monthly'
                        });
                    } else {
                        this.setState({
                            latePaymentMonthlyCharge: '0',
                            latePaymentCharge: 'dont_charge'
                        });
                    }


                    this.setState({
                        referenceNumber: response.data.quotation[0].REFERENCE_NO,
                        //customerCode: { value: response.data.quotation[0].CUSTOMER_ID, label: response.data.quotation[0].CUSTOMER_ID },
                        customerVatNumber: response.data.quotation[0].CUSTOMER_VAT_NO,
                        billDate: new Date(date)
                    });



                    this.setState({ loading: false });
                }
                else {
                    this.setState({ loading: false });

                    console.log('error', response.data.error);
                }
            })
                .catch((error) => {
                    // Error
                    if (error && typeof error === 'undefined') {
                        console.log('login axios error block', error);
                    }
                    else if (error) {
                        console.log('error', error);
                    }
                    this.setState({ loading: false });

                });


            var url2 = window.salesServer + "/quotation/getQuotationItemsById";
            let body2 = {
                id: selectedOption.value
            };
            const request2 = axios.post(url2, body2);

            request2.then((response) => {

                if (!response.data.error && response.data.success) {
                    console.log('item data recieved', response.data);

                    var items = response.data.items;
                    var itemRecords = [];
                    for (let i = 0; i < items.length; i++) {
                        let itemRow = {
                            itemCode: items[i].ITEM_ID, itemName: items[i].ITEM_NAME, isService: items[i].IS_SERVICE, quantity: items[i].ITEM_QTY,
                            unitPrice: items[i].UNIT_PRICE, discount: items[i].DISCOUNT, isDiscountPercentage: items[i].IS_DISCOUNT_PERCENTAGE,
                            netPrice: items[i].NET_PRICE
                        };
                        itemRecords.push(itemRow);
                    }
                    this.setState({ records: itemRecords });
                    console.log('records', this.state.records);

                }
                this.setState({ loading: false });
            })
                .catch((error) => {
                    // Error
                    if (error && typeof error === 'undefined') {
                        console.log('login axios error block', error);
                    }
                    else if (error) {
                        console.log('error', error);
                    }
                    this.setState({ loading: false });

                });

            console.log(`Selected: ${selectedOption.label}`);
        }
    }

    handleCusTypeChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ customerType: selectedOption.value, /* customerType2:selectedOption.value */ })
        }
        else {
            this.setState({ customerType: 'All',/*  customerType2: 'all' */ });
        }
    }

    handleCusCodeChange = (selectedOption) => {
        console.log('cuscodechange called', selectedOption);



        // selectedOption can be null when the `x` (close) button is clicked
        if (selectedOption) {

            for (let i = 0; i < this.state.customers.length; i++) {
                console.log('cuscodechange loop', this.state.customers[i]._id, selectedOption.value);

                if (this.state.customers[i]._id == selectedOption.value) {
                    console.log('found', this.state.customers[i], selectedOption.value);
                    this.setState({ currentCustomerAddress: this.state.customers[i].CUSTOMER_PROFILE.cx_postal_address });
                    this.setState({ customerName: { value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name } },
                        () => { console.log('Customer name value', this.state.customerName.value) }
                    );

                    this.setState({ customerVatNumber: this.state.customers[i].CUSTOMER_PROFILE.cx_tax }, () => {
                        console.log("Customet VAT :", this.state.customerVatNumber)
                    });
                    //added by Achira
                    this.setState({ customerCode: { value: selectedOption.value, label: this.state.customers[i].CUSTOMER_CODE } },
                        () => {
                            console.log('this.state.customerCode', this.state.customerCode);
                            console.log('getJobsByCustomer', this.getJobsByCustomer());
                        });
                    this.setState({ customerType: this.state.customers[i].CUSTOMER_PROFILE.cx_type });
                    //this.setState({ customerType2: this.state.customers[i].CUSTOMER_PROFILE.cx_type });
                    this.setState({ customerPrivilageDiscount: this.state.customers[i].CUSTOMER_PROFILE.cx_previlage_discount });
                    break;
                }
            }

            console.log(`Selected: ${selectedOption.value}`);
        }
        else {
            this.setState({ customerCode: '' },
                () => {
                    console.log('getJobsByCustomer', this.getJobsByCustomer());
                });
            this.setState({ customerName: '', customerType: 'All', currentCustomerAddress: '' });

        }

        let quotationList = [];
        for (let i = 0; i < this.state.rawQuotations.length; i++) {
            if (selectedOption) {
                if (this.state.rawQuotations[i].CUSTOMER_ID == selectedOption.value) {
                    quotationList.push({ value: this.state.rawQuotations[i].ID_INVOICE_HEADER, label: this.state.rawQuotations[i].REFERENCE_NO, });
                }
            }
            else {
                quotationList.push({ value: this.state.rawQuotations[i].ID_QUOTATION_HEADER, label: this.state.rawQuotations[i].REFERENCE_NO, });
            }
        }

        this.setState({ quotationNumbers: quotationList });


    }

    handleCusNameChange = (selectedOption) => {

        // selectedOption can be null when the `x` (close) button is clicked
        if (selectedOption) {
            this.setState({ customerName: selectedOption });
            for (let i = 0; i < this.state.customers.length; i++) {
                if (this.state.customers[i]._id == selectedOption.value) {
                    //console.log('found');
                    this.setState({ currentCustomerAddress: this.state.customers[i].CUSTOMER_PROFILE.cx_postal_address });
                    this.setState({ customerCode: { value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_CODE } });
                    this.setState({ customerType: this.state.customers[i].CUSTOMER_PROFILE.cx_type });
                    this.setState({ customerVatNumber: this.state.customers[i].CUSTOMER_PROFILE.cx_tax }, () => {
                        console.log("Customet VAT :", this.state.customerVatNumber)
                    });
                    //added by Achira
                    //this.setState({ customerType2: this.state.customers[i].CUSTOMER_PROFILE.cx_type });
                    this.setState({ customerPrivilageDiscount: this.state.customers[i].CUSTOMER_PROFILE.cx_previlage_discount });
                    break;
                }
            }
            console.log(`Selected: ${selectedOption.value}`);
        }
        else {
            this.setState({ customerName: '' });
            this.setState({ customerCode: '', customerType: 'All', currentCustomerAddress: '' /* customerType2: 'all' */ });
        }

        let quotationList = [];
        for (let i = 0; i < this.state.rawQuotations.length; i++) {
            if (selectedOption) {
                if (this.state.rawQuotations[i].CUSTOMER_ID == selectedOption.value) {
                    quotationList.push({ value: this.state.rawQuotations[i].ID_INVOICE_HEADER, label: this.state.rawQuotations[i].REFERENCE_NO, });
                }
            }
            else {
                quotationList.push({ value: this.state.rawQuotations[i].ID_QUOTATION_HEADER, label: this.state.rawQuotations[i].REFERENCE_NO, });
            }
        }

        this.setState({ quotationNumbers: quotationList });
    }

    handleBrokerNameChange = (selectedOption) => {

        // selectedOption can be null when the `x` (close) button is clicked
        if (selectedOption) {
            this.setState({ broker: selectedOption.value });
            console.log(`Selected: ${selectedOption.value}`);
        }
        else {
            this.setState({ broker: '' });
        }
    }


    handleRadioChange = event => {

        this.setState({ selectedTaxOption: event.target.value, isProformaInvoice: false, isQuotation: false })
    };

    handleSelectChange = name => event => {
        /* if (name == 'customerType') {
            this.setState({ customerCode: '', customerName: '' });
        } */
        if (name == 'paymentTerm') {
            this.setState({ paymentNetDate: null, paymentTermByDays: '' });
        }
        this.setState({ [name]: event.target.value });
    };


    handleCheckBoxChange = name => event => {

        this.setState({ selectedTaxOption: event.target.value, isProformaInvoice: false })

        this.setState({ [name]: event.target.checked });
        if (name !== 'isQuotation') {
            this.state.isQuotation = false;
        }else{
            this.state.isQuotation = true;
        }
    };

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };


    populateFileds() {
        console.log('populating fields...');
        this.setState({ loading: true });

        this.getCustomerTypes();
        this.getQuotations();
        this.getCustomers();
        this.getBrokers();
        this.getJobList();
        /* let currentDate = new Date();
        this.setState({billDate:currentDate}); */
    }



    getJobList() {
        console.log('getting jobs...');

        this.setState({ loading: true });
        const request = axios.get(window.crmServer + '/job/min');
        request.then((response) => {

            if (!response.data.error) {
                //console.log('data recieved', response.data);
                let jobList = [];

                if (response.data.result) {
                    response.data.result.map(item => {
                        jobList.push({
                            value: item.ID_JOB_REGISTRY,
                            label: item.JOB_CODE_PREFIX + item.JOB_CODE + item.JOB_CODE_SUFFIX,
                            customerId: item.CUSTOMER_ID
                        });
                    });
                }

                this.setState({ jobList: jobList });

                console.log('jobList', jobList);

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    getBrokers() {
        console.log('getting brokers...');

        this.setState({ loading: true });
        const request = axios.get(window.salesServer + '/broker/getBrokerList');
        request.then((response) => {

            if (!response.data.error) {
                //console.log('data recieved', response.data);
                let borkerList = [];

                for (let i = 0; i < response.data.brokers.length; i++) {
                    borkerList.push({ value: response.data.brokers[i].ID_SALES_BROKER, label: response.data.brokers[i].NAME });
                }

                this.setState({ borkerList: borkerList });

                console.log('borkerList', borkerList);

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    getCustomers() {
        console.log('getting customers...');

        this.setState({ loading: true });
        const request = axios.get(window.crmServer + '/crm/getCustomer/all');
        request.then((response) => {

            // console.log('data recieved', response.data.result);
            if (!response.data.error) {
                let customerCodes = [];
                let customerNames = [];
                let customers = [];
                for (let i = 0; i < response.data.result.length; i++) {
                    // console.log('response.data[i].CUSTOMER_PROFILE.cx_active : ' + response.data[i].CUSTOMER_CODE + ' ,' + response.data[i].CUSTOMER_PROFILE.cx_active);
                    if (response.data.result[i].CUSTOMER_PROFILE) {
                        if (response.data.result[i].CUSTOMER_PROFILE.cx_active !== false) {
                            // console.log('matched');
                            customerCodes.push({ value: response.data.result[i]._id, label: response.data.result[i] ? response.data.result[i].CUSTOMER_CODE : "" });
                            customerNames.push({ value: response.data.result[i]._id, label: response.data.result[i].CUSTOMER_PROFILE.cx_name });
                            customers.push(response.data.result[i]);
                        }
                    }
                }
                this.setState({ customerCodes: customerCodes });
                this.setState({ customerNames: customerNames });
                this.setState({ customers: customers });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    getCustomerTypes() {
        console.log('getting customer types...');
        //this.setState({ loading: true });
        const request = axios.get(window.systemServer + '/system/loadCustomerTypes');
        request.then((response) => {
            if (window.DATABASE_TYPE == "MYSQL")
                if (response.data.success) {
                    let data = [];
                    data = (response.data.result.slice());
                    this.setState({ customerTypes: data });

                    // let customerTypes = [{ value: 'all', label: 'All' }];
                    let customerTypes = [];
                    for (let i = 0; i < response.data.result.length; i++) {
                        customerTypes.push({ value: response.data.result[i].customer_type, label: response.data.result[i].customer_type });
                    }
                    this.setState({ customerTypes: customerTypes });
                    this.setState({ loading: false });
                }
                else {
                    console.log('error', response.data.result);
                    this.setState({ loading: false });
                }
            else
                if (!response.data.error) {

                    let data = [];
                    data = (response.data.slice());
                    this.setState({ customerTypes: data });

                    // let customerTypes = [{ value: 'all', label: 'All' }];
                    let customerTypes = [];
                    for (let i = 0; i < response.data.length; i++) {
                        customerTypes.push({ value: response.data[i].customer_type, label: response.data[i].customer_type });
                    }
                    this.setState({ customerTypes: customerTypes });
                    this.setState({ loading: false });
                }
                else {
                    console.log('error', response.data.error);
                    this.setState({ loading: false });
                }
        });
    }


    getQuotations() {
        console.log('getting quotations...');
        //this.setState({ loading: true });
        const request = axios.get(window.salesServer + '/quotation/getQuotations');
        request.then((response) => {

            if (!response.data.error) {
                console.log('quotation data recieved', response.data);
                let data = [];
                //data = (response.data.quotations.slice());

                for (let i = 0; i < response.data.quotations.length; i++) {
                    data.push({ value: response.data.quotations[i].ID_QUOTATION_HEADER, label: response.data.quotations[i].REFERENCE_NO });
                }

                this.setState({ rawQuotations: response.data.quotations, quotationNumbers: data });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    componentWillMount() { }

    render() {
        const { selectedDay } = this.state;
        const parseDate = '2018-06-06';

        const tdStyle = { 'width': '14.285714%' };

        var divStyle = (value, stateC) => {
            if (stateC == value) {
                return { display: 'inline-block', margin: 0 };
            }
            else {
                return { display: 'none', margin: 0 };
            }
        };

        var divStyleBlock = (value, stateC) => {
            if (stateC == value) {
                return { display: 'block', margin: 0 };
            }
            else {
                return { display: 'none', margin: 0 };
            }
        };

        var blockStyle = { display: 'block', margin: 0 };

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        const { classes } = this.props;

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                    <div className="p-8">
                        <h2 className="subtitle-color invoice-margin">Invoice</h2>
                    </div>

                    <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 invoice-form-color">
                        <div className="p-8">
                            <table className="table-auto border-collapse" style={{ 'border-collapse': 'collapse' }}>

                                <tr>
                                    <td align="center" className='w-1/8'>
                                        <div className="w-full mt-8 sm:mt-0 md:text-center sm:text-left  px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                            {/* this.state.billDate && <p>Bill Date: {this.state.billDate.toLocaleDateString()}</p> */}
                                            <p>Invoice Date:</p>
                                            <DayPickerInput className="bg-orange" onDayChange={this.handleBillDateChange} selectedDays={this.state.billDate}
                                                placeholder={"YYYY-MM-DD"} />

                                        </div>
                                    </td>


                                    {/* <div className="w-1/9 inline-block">
                                <TextField
                                    id="name"
                                    label="Reference Number"
                                    className="w-full px-4"
                                    className={classes.textField}
                                    classes={{
                                        input: classes.input
                                    }}
                                    value={this.state.referenceNumber}
                                    onChange={this.handleTextBoxChange('referenceNumber')}
                                />
                            </div> */}

                                    <td align="center" className='w-1/8'>
                                        <div className="w-full mt-8 sm:mt-0 md:text-center sm:text-left  px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                            <TextField
                                                id="name"
                                                label="Reference Number"
                                                // className={classes.textField}
                                                value={this.state.referenceNumber}
                                                onChange={this.handleTextBoxChange('referenceNumber')}
                                                variant="outlined"
                                            />
                                        </div>
                                    </td>
                                    {/* <div className="w-full   sm:w-1/3 md:w-1/6 mt-8 sm:mt-0 inline-block">
                                <FormControlLabel
                                    className="m-0"
                                    control={
                                        <Checkbox
                                            checked={this.state.isQuotation}
                                            onChange={this.handleCheckBoxChange('isQuotation')}
                                            color="primary"
                                        />
                                    }
                                    label="Quotation"
                                />
                            </div> */}

                                    <div className="sm:mt-0 bg-orange-lighter" style={{ margin: '10px', position: 'relative', left: '26px' }}>
                                        <td align="center" className='w-1/8'>
                                            <div className="w-full mt-8 sm:mt-0 md:text-center sm:text-left  px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                                <FormControlLabel
                                                    //className="md:mb-24 sm:mb-0"
                                                    control={
                                                        <Radio
                                                            checked={this.state.selectedTaxOption === 'isQuotation'}
                                                            onChange={this.handleCheckBoxChange('isQuotation')}
                                                            value="isQuotation"
                                                            name="isQuotation"
                                                            aria-label="A"
                                                            color="default"
                                                        />
                                                    }
                                                    label="Quotation"
                                                />
                                            </div>
                                        </td>
                                        <td align="center" className='w-1/8'>
                                            <div className="w-full mt-8 sm:mt-0 md:text-center sm:text-left  px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                                <FormControlLabel
                                                    //className="md:mb-24 sm:mb-0"
                                                    control={
                                                        <Radio
                                                            checked={this.state.selectedTaxOption === 'tax_invoice'}
                                                            onChange={this.handleRadioChange}
                                                            value="tax_invoice"
                                                            name="tax_invoice"
                                                            aria-label="A"
                                                            color="default"
                                                        />
                                                    }
                                                    label="TAX Invoice"
                                                />
                                            </div>
                                        </td>
                                        <td align="center" className='w-1/8'>
                                            <div className="w-full mt-8 sm:mt-0  md:text-center sm:text-left px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                                <FormControlLabel
                                                    //className="md:mb-24 sm:mb-0"
                                                    control={
                                                        <Radio
                                                            checked={this.state.selectedTaxOption === 'non_tax_invoice'}
                                                            onChange={this.handleRadioChange}
                                                            value="non_tax_invoice"
                                                            name="non_tax_invoice"
                                                            aria-label="A"
                                                            color="default"
                                                        />
                                                    }
                                                    label="Non TAX Invoice"
                                                />
                                            </div>
                                        </td>
                                        <td align="center" className='w-1/8'>
                                            <div className="w-full mt-8 sm:mt-0  md:text-center sm:text-left px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                                <FormControlLabel
                                                    //className="md:mb-24 sm:mb-0"
                                                    control={
                                                        <Radio
                                                            checked={this.state.selectedTaxOption === 'suspended_tax_invoice'}
                                                            onChange={this.handleRadioChange}
                                                            value="suspended_tax_invoice"
                                                            name="suspended_tax_invoice"
                                                            aria-label="A"
                                                            color="default"
                                                        />
                                                    }
                                                    label="Suspended TAX Invoice"
                                                />
                                            </div>
                                        </td>
                                        <td align="center" className='w-1/8'>
                                            <div className="w-full mt-8 sm:mt-0  md:text-center sm:text-left px-4" /* style={divStyle(false, this.state.isQuotation)} */>
                                                <FormControlLabel
                                                    //className="md:mb-24 sm:mb-0"
                                                    control={
                                                        <Radio
                                                            checked={this.state.selectedTaxOption === 'isProformaInvoice'}
                                                            onChange={this.handleCheckBoxChange('isProformaInvoice')}
                                                            value="isProformaInvoice"
                                                            name="isProformaInvoice"
                                                            aria-label="A"
                                                            color="default"
                                                        />
                                                    }
                                                    label="Proforma Invoice"
                                                />
                                            </div>
                                        </td>
                                    </div>
                                </tr>
                            </table>
                        </div>



                        {/* <Divider className="md:-mt-16 sm:mt-8" style={blockStyle} /> */}



                        {/* <Divider className="mt-12 mb-12" /> */}


                        <table className="table-auto border-collapse" style={{ 'border-collapse': 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td align="center" className='w-1/6'>
                                        <div className='w-full px-8  inline'>
                                            Customer Type *
                                            <Select
                                                className="w-full"
                                                name="form-field-name"
                                                placeholder="Select Customer Type"
                                                value={this.state.customerType}
                                                onChange={this.handleCusTypeChange}
                                                //options={this.state.customerNames}
                                                options={this.state.customerTypes}
                                            />
                                        </div>
                                    </td>
                                    <td align="center" className='w-1/6'>
                                        <div className="w-full sm:w-full md:w-full px-8  inline">
                                            Customer Code *
                                            <Select
                                                className="w-full"
                                                name="form-field-name"
                                                placeholder="Search Cusotmer Code"
                                                value={this.state.customerCode}
                                                onChange={this.handleCusCodeChange}
                                                //options={this.state.customerCodes}
                                                options={this.customersByCustomerType().customerCodes}
                                            />
                                        </div>
                                    </td>
                                    <td align="center" className='w-1/6'>
                                        <div className="w-full px-8  inline">
                                            Customer Name *
                                            <Select
                                                className="w-full"
                                                name="form-field-name"
                                                placeholder="Search Customer Name"
                                                value={this.state.customerName}
                                                onChange={this.handleCusNameChange}
                                                options={this.customersByCustomerType().customerNames}  // Uncomment this line
                                            >
                                                {this.customersByCustomerType().customerNames.map(option => (
                                                    <MenuItem value={option.value} key={option.value}>
                                                        {option.toolTip ? (
                                                            <Tooltip title={option.toolTip}>
                                                                <span>{option.label}</span>
                                                            </Tooltip>
                                                        ) : (
                                                            option.label
                                                        )}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </div>
                                    </td>
                                    <td>
                                        <div >

                                            <TextField
                                                fullWidth
                                                id="outlined-multiline-flexible"
                                                // label="  Customer Address *"
                                                // multiline
                                                // rowsMin="4"
                                                value={this.state.currentCustomerAddress && this.state.currentCustomerAddress}
                                                className={classes.textField}
                                                margin="normal"
                                                variant="outlined"
                                                disabled
                                            />

                                        </div>
                                    </td>
                                    {/* <td align="center" className='w-1/6'>
                                    <div className="w-full">
                                        <TextField
                                        id="outlined-multiline-flexible"
                                        label="Remark"
                                        multiline
                                        rowsMin="4"
                                        value={this.state.remark}
                                        onChange={this.handleTextBoxChange('remark')}
                                        className="w-3/4"
                                        margin="normal"
                                        variant="outlined"
                                        />
                                </div>
                                    </td> */}
                                </tr>
                                <tr>
                                    <td align="center" className='w-1/5'>
                                        <div className="w-full px-8  inline-block " style={{ display: this.state.isQuotation ? 'none' : 'inline' }}>
                                            Recall Quotation
                                            <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Select Quotation"
                                                value={this.state.quotationNumber}
                                                onChange={this.handleQuotationChange}
                                                options={this.state.quotationNumbers}
                                            />
                                        </div>
                                    </td>
                                    <td align="center" className='w-1/5'>
                                        <div className="w-full px-8  inline-block " style={{ display: this.state.isQuotation ? 'none' : 'inline' }}>
                                            Job
                                            <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Select Job"
                                                value={this.state.job}
                                                onChange={this.handleJobChange}
                                                //options={this.state.jobList}
                                                options={this.getJobsByCustomer()}
                                            />
                                        </div>
                                    </td>
                                    <td align="center" className='w-1/5'>
                                        <div className="w-full px-8  inline-block " style={{ display: 'inline' }}>
                                            Broker
                                            <Select
                                                className=""
                                                name="form-field-name"
                                                placeholder="Search Broker"
                                                value={this.state.broker}
                                                onChange={this.handleBrokerNameChange}
                                                options={this.state.borkerList}
                                                inputProps={{
                                                    name: 'selBroker',
                                                    id: 'selBroker',
                                                }}
                                            />

                                        </div>
                                    </td>
                                    <td align="center" className='w-1/5'>
                                        <DialogActions className=" pl-16 billing-btn-margins">
                                            <Button
                                                style={{ position: 'relative', top: '30px', left: '-41px' }}
                                                className="w-1/5  " //position: relative
                                                variant="raised"
                                                color="primary"
                                                className={classes.button}
                                                aria-label="Add new broker"
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleAddNewBrokerClick();
                                                }}
                                            >
                                                Add New Broker
                                            </Button>

                                        </DialogActions>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="pt-8" >
                            <div className="w-full">

                                <TextField
                                    id="outlined-multiline-flexible"
                                    label="Remark"
                                    multiline
                                    rowsMax="4"
                                    value={this.state.remark}
                                    onChange={this.handleTextBoxChange('remark')}
                                    className="w-3/4"
                                    margin="normal"
                                    variant="outlined"
                                />
                            </div>
                        </div>

                        <div className="pt-8" >










                        </div>
                    </fieldset>

                    <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 invoice-form-color">

                        <div className="w-full row">

                            <div className="w-full md:w-1/5 sm:w-full inline-block">

                                <div className="w-full md:w-2/5 sm:w-full inline-block">
                                    <TextField className=""
                                        id="vatNo"
                                        label="VAT Number"
                                        className={classes.textField}
                                        value={this.state.customerVatNumber}
                                        onChange={this.handleTextBoxChange('customerVatNumber')}
                                    />
                                </div>
                            </div>


                            <div className="w-full md:w-2/5 sm:w-full inline-block">
                                <div className="w-1/2 inline-block pl-20">
                                    <InputLabel htmlFor="selPaymentTerm" className="sm:w-1/2">Payment Term</InputLabel>
                                    <MSelect
                                        className="w-full sm:1/2"
                                        //
                                        label="Payment Term"
                                        value={this.state.paymentTerm}
                                        onChange={this.handleSelectChange('paymentTerm')}
                                        inputProps={{
                                            name: 'selPaymentTerm',
                                            id: 'selPaymentTerm',
                                        }}
                                    >

                                        <MenuItem className="popup-value-size" value="select_payment_term">Select Payment Term</MenuItem>
                                        <MenuItem className="popup-value-size" value="net">Net</MenuItem>
                                        <MenuItem className="popup-value-size" value="by">By</MenuItem>

                                    </MSelect>
                                </div>

                                <div style={divStyle('by', this.state.paymentTerm)} className="w-1/2 ml-20 inline-block day-margin">
                                    <TextField
                                        id="paymentTermBy"
                                        label="By days"
                                        className="w-full"
                                        className={classes.textField}
                                        value={this.state.paymentTermByDays}
                                        onChange={this.handleTextBoxChange('paymentTermByDays')}
                                    />

                                    {/* <DatePicker
                            selected={this.state.paymentTermByNetDate}
                            onChange={this.handlePaymentDateChange}
                            /> */}


                                </div>

                                <div style={divStyle('net', this.state.paymentTerm)} className="w-1/2 inline-block net-margin">
                                    <p>Choose a day</p>
                                    <DayPickerInput onDayChange={this.handlePaymnetDayChange} />
                                </div>

                            </div>

                            <div className="p-4 w-full md:w-2/5 sm:w-full inline-block paymet-margin">

                                <div className="w-1/2 inline-block pl-20">
                                    <InputLabel htmlFor="selLatePaymentCharge" className="sm:1/2">Late Payment Charge</InputLabel>
                                    <MSelect
                                        className="w-full sm:1/2"
                                        //
                                        label="Late Payment Charge"
                                        value={this.state.latePaymentCharge}
                                        onChange={this.handleSelectChange('latePaymentCharge')}
                                        //input={<Input name="name" id="latePaymentChargeSel" readOnly />}
                                        inputProps={{
                                            name: 'selLatePaymentCharge',
                                            id: 'selLatePaymentCharge',
                                        }}
                                    >

                                        <MenuItem className="popup-value-size" value="dont_charge">Do not charge</MenuItem>
                                        <MenuItem className="popup-value-size" value="monthly">Monthly</MenuItem>

                                    </MSelect>
                                </div>



                                <div style={divStyle('monthly', this.state.latePaymentCharge)} className="w-1/2 pl-20 monthly-charge inline-block">
                                    <TextField
                                        className=""
                                        id="monthlyLatePaymentCharge"
                                        label="Monthly charge"
                                        value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        // className={classes.textField}
                                        onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    %
                                    <Checkbox style={{ position: 'relative', left: '170px', bottom: ' 41px' }} className='pl-20'
                                        checked={this.state.isLatePaymentChargePercentage}
                                        onChange={this.handleCheckBoxChange('isLatePaymentChargePercentage')}
                                        color="primary"
                                    />

                                </div>
                            </div>


                        </div>

                    </fieldset>

                    {/* <Divider className="mt-12 mb-12" /> */}

                    <div className="w-full mt-16 ">
                        <ItemAdder customerType={this.state.customerType} records={this.state.records}
                            selectedTaxOption={this.state.selectedTaxOption} updateValues={this.getItemAdderState} />
                    </div>

                    {/* <div>
                        <TextField
                            id="outlined-multiline-flexible"
                            label="Remark"
                            multiline
                            rowsMax="4"
                            value={this.state.remark}
                            onChange={this.handleTextBoxChange('remark')}
                            className={classes.textField}
                            margin="normal"
                            variant="outlined"
                        />
                    </div> */}

                    <div className="mt-8 mr-20 float-right payment-save-button">
                        <Button
                            className=""
                            variant="raised"
                            color="secondary"
                            className={classes.button}
                            disabled={!this.state.customerCode || this.state.customerCode == ''}
                            aria-label="Save"
                            onClick={(ev) => {
                                ev.stopPropagation();

                                this.handleSaveClick();
                            }}
                        >
                            Save
                        </Button>
                    </div>

                    {/*  <div className="mt-8 mr-20 float-LEFT">
                        <Button
                            className=""
                            variant="raised"
                            color="primary"
                            className={classes.button}
                            onClick={(ev) => {
                                ev.stopPropagation();

                                this.handleDNClick();
                            }}
                        >
                            DN
                                            </Button>
                    </div> */}

                    {this.redirectToDN()}
                    {this.redirectToNewBroker()}
                </div>
            )


        }
    }

    handleDNClick() {
        this.setState({
            redirect: true
        })
    }

    handleAddNewBrokerClick() {
        this.setState({
            redirectToNewBroker: true
        })
    }

    redirectToDN() {
        if (this.state.redirect) {
            return (
                <Redirect
                    to={{
                        pathname: "/sales/deliveryNote",
                        state: { refNo: this.state.refParser }
                    }}
                />
            )
        }
    }

    redirectToNewBroker() {
        if (this.state.redirectToNewBroker) {
            return (
                <Redirect
                    to={{
                        pathname: "/sales/broker"
                    }}
                />
            )
        }
    }

    handleSaveClick() {
        console.log('Save pre validations billdate', this.state.billDate);
        var billDate;
        /* if(this.state.billDate==''){
            billDate = moment(new Date()).format("YYYY-MM-DD");
        }else{
            billDate = this.state.billDate
        } */
        if (this.state.billDate == undefined) {

            confirmAlert({
                title: 'Bill Date', message: 'Select a valid bill date',
                buttons: [{ label: 'Ok' }]
            })
            return;
        }


        var discountGiven = this.state.sumValues.isDiscountPercentage ?
            parseFloat(this.state.sumValues.grossAmount) * parseFloat(this.state.sumValues.discount) / 100
            : this.state.sumValues.discount;

        var privilagedDiscount = 0.00;
        if (this.state.customerPrivilageDiscount) {
            var privilagedDiscount = (parseFloat(this.state.customerPrivilageDiscount)) / 100 * parseFloat(this.state.sumValues.grossAmount);
        } else {
            privilagedDiscount = null;
        }
        console.log('privilagedDiscount', privilagedDiscount);
        console.log('discountGiven', discountGiven);

        if (privilagedDiscount && parseFloat(parseFloat(privilagedDiscount).toFixed(2)) < parseFloat(parseFloat(discountGiven).toFixed(2))) {

            confirmAlert({
                title: 'Item price', message: 'Customer discount privilage limit exceeded. Limit is ' + parseFloat(this.state.customerPrivilageDiscount) + '%',
                buttons: [{ label: 'Ok' }]
            })
            return;
        }

        if (this.state.isQuotation) {
            this.createQuotation();
        }
        else {
            this.createInvoice();
        }
    }

    createQuotation() {

        this.setState({ loading: true });

        var billDate = moment(this.state.billDate).format("YYYY-MM-DD");


        // added by Achira
        var transportAndExtra = 0;

        var newNetAmount;

        console.log('transportAndExtra', this.state.sumValues.transportAndExtra);

        try {
            transportAndExtra = parseFloat(this.state.sumValues.transportAndExtra);
            newNetAmount = parseFloat(this.state.sumValues.netAmount).toFixed(2);
        }
        catch (error) {
            console.log('parseFloat error', error);
            transportAndExtra = 0;
        }

        var newTransportAndExtra = transportAndExtra;

        if (this.state.selectedTaxOption === 'non_tax_invoice') {

            // var vat = parseFloat(transportAndExtra) * 15/100;
            // var nbt = parseFloat(vat) * 2/100;

            newTransportAndExtra = parseFloat(transportAndExtra) * 102 / 100 * 115 / 100;
            newTransportAndExtra = parseFloat(parseFloat(newTransportAndExtra).toFixed(2));
            newNetAmount = parseFloat(newNetAmount) - transportAndExtra + parseFloat(newTransportAndExtra);
            console.log('newTransportAndExtra', newTransportAndExtra);
            console.log('newNetAmount', newNetAmount);

            /* transportAndExtra = parseFloat(transportAndExtra) +  parseFloat(vat) + parseFloat(nbt);
            transportAndExtra = transportAndExtra.toFixed(2); */
        }

        ///-----------------------------------------------------------------------------------------------------

        var quotationRow = {
            BILL_DATE: billDate,
            REFERENCE_NO_2: this.state.referenceNumber,
            CUSTOMER_ID: this.state.customerCode.value,
            CUSTOMER_CODE: this.state.customerCode.label,
            CUSTOMER_NAME: this.state.customerName.label,
            CUSTOMER_VAT_NO: this.state.customerVatNumber,
            TAX_TYPE: this.state.selectedTaxOption,
            PAYMENT_TERM_NET: this.state.paymentNetDate ? moment(this.state.paymentNetDate).format("YYYY-MM-DD") : null,
            PAYMENT_TERM_BY: (this.state.paymentTermByDays == '') ? null : this.getNumberDefyNullZero(this.state.paymentTermByDays),
            LATE_PAYMENT_CHARGE: this.state.latePaymentMonthlyCharge,
            IS_LATE_PAYMENT_CHARGE_PERCENTAGE: this.state.isLatePaymentChargePercentage,
            TRANSPORT_AND_EXTRA: parseFloat(newTransportAndExtra).toFixed(2),
            GROSS_AMOUNT: this.state.sumValues.grossAmount,
            // NBT:this.state.selectedTaxOption=='non_tax_invoice'?'0.00':this.state.sumValues.NBT,
            // VAT: this.state.selectedTaxOption=='non_tax_invoice'?'0.00':this.state.sumValues.VAT,
            DISCOUNT: this.state.sumValues.discount,
            IS_DISCOUNT_PERCENTAGE: this.state.sumValues.isDiscountPercentage,
            NET_AMOUNT: parseFloat(newNetAmount).toFixed(2),
            REMARK: this.state.remark
        }



        if (this.state.broker != '') {
            quotationRow.ID_SALES_BROKER = this.state.broker;
        }

        console.log('sumValues', this.state.sumValues);

        console.log('quotationRow', quotationRow);


        var url = window.salesServer + "/quotation/createQuotation";
        //var url = "http://localhost:5006/quotation/createQuotation";
        let body = quotationRow;

        const request = axios.post(url, body);

        request.then((response) => {

            if (response.data.error || !response.data.success) {
                this.setState({ loading: false, billDate: new Date() });
                if (response.data.message == 'duplicate') {
                    return this.props.alert.error('Reference number already exist');
                }
                return this.props.alert.error('Quotation create failed');
            }

            this.props.alert.success('Quotation created');
            console.log('Quotation created', response.data);

            //var url2 = "http://localhost:5006/quotation/addQuotationItems";
            var url2 = window.salesServer + "/quotation/addQuotationItems";
            var body2 = [];

            //console.log('before loop state selected items', this.state.selectedItems)
            //console.log('before loop',  body2);
            for (let i = 0; i < this.state.selectedItems.length; i++) {
                //console.log('in loop body2', body2);
                body2.push(this.state.selectedItems[i].concat([response.data.quotationId, 1]))
            }

            //console.log('afterloop state selected items', this.state.selectedItems)
            //console.log('after loop body2', body2);

            const request2 = axios.post(url2, body2);

            request2.then((response2) => {

                if (response2.data.error && !response2.data.success) {
                    return this.props.alert.error('Adding items to quotation failed');
                    console.log('Adding items to quotation failed', response2.data);
                }
                this.props.alert.success('Items added to quotation');
                this.setState({ loading: false, billDate: new Date() });
                this.getQuotationReport(response.data.REFERENCE_NO);
            })
                .catch((error) => {
                    // Error
                    if (error && typeof error === 'undefined') {
                        console.log('login axios error block', error);
                    }
                    else if (error) {
                        console.log('error', error);
                    }
                    this.props.alert.error('Adding items to quotation error');
                    this.setState({ loading: false, billDate: new Date() });

                });

            this.setState({ loading: false, billDate: new Date() });
        })
            .catch((error) => {
                // Error
                if (error && typeof error === 'undefined') {
                    console.log('login axios error block', error);
                }
                else if (error) {
                    console.log('error', error);
                }
                this.props.alert.error('Creating quotation error');
                this.setState({ loading: false, billDate: new Date() });

            });

    }

    getQuotationReport(referenceNumber) {
        console.log('getQuotationReport', referenceNumber);
        var path = null;
        axios.get(window.reportServer + '/report/get/reportQuotationForImc',
            {
                params: {
                    refId: referenceNumber
                }
            }
        )
            .then(response => {
                path = response.data.path;
                path = window.reportServer + "/" + path;
                const url = path;
                window.open(url, '_blank');
            }
            );
    }

    createInvoice() {
        this.setState({ loading: true });

        var billDate = moment(this.state.billDate).format("YYYY-MM-DD");

        //console.log('biil date', billDate);

        // var NBT;
        // var VAT;
        // if (this.state.selectedTaxOption == 'tax_invoice') {
        //     // NBT = this.state.sumValues.NBT;
        //     VAT = this.state.sumValues.VAT;
        // } else if (this.state.selectedTaxOption == 'suspended_tax_invoice') {
        //     // NBT = this.state.sumValues.NBT;
        //     VAT = 0.00;
        // } else if (this.state.selectedTaxOption == 'non_tax_invoice') {
        //     // NBT = 0.00;
        //     VAT = 0.00;
        // }

        var transportAndExtra = 0;

        var newNetAmount;

        console.log('transportAndExtra', this.state.sumValues.transportAndExtra);

        try {
            transportAndExtra = parseFloat(this.state.sumValues.transportAndExtra);
            newNetAmount = parseFloat(this.state.sumValues.netAmount).toFixed(2);
        }
        catch (error) {
            console.log('parseFloat error', error);
            transportAndExtra = 0;
        }

        var newTransportAndExtra = transportAndExtra;

        if (this.state.selectedTaxOption === 'non_tax_invoice') {

            // var vat = parseFloat(transportAndExtra) * 15/100;
            // var nbt = parseFloat(vat) * 2/100;

            newTransportAndExtra = parseFloat(transportAndExtra) * 102 / 100 * 115 / 100;
            newTransportAndExtra = parseFloat(parseFloat(newTransportAndExtra).toFixed(2));
            newNetAmount = parseFloat(newNetAmount) - transportAndExtra + parseFloat(newTransportAndExtra);
            console.log('newTransportAndExtra', newTransportAndExtra);
            console.log('newNetAmount', newNetAmount);

            /* transportAndExtra = parseFloat(transportAndExtra) +  parseFloat(vat) + parseFloat(nbt);
            transportAndExtra = transportAndExtra.toFixed(2); */
        }

        //alert(transportAndExtra);

        var invoiceRow = {
            BILL_DATE: billDate,
            REFERENCE_NO_2: this.state.referenceNumber,
            CUSTOMER_ID: this.state.customerCode.value,
            CUSTOMER_CODE: this.state.customerCode.label,
            CUSTOMER_NAME: this.state.customerName.label,
            CUSTOMER_VAT_NO: this.state.customerVatNumber,
            JOB_NO: this.state.job,
            TAX_TYPE: this.state.selectedTaxOption,
            PAYMENT_TERM_NET: this.state.paymentNetDate ? moment(this.state.paymentNetDate).format("YYYY-MM-DD") : null,
            PAYMENT_TERM_BY: (this.state.paymentTermByDays == '') ? null : this.getNumberDefyNullZero(this.state.paymentTermByDays),
            LATE_PAYMENT_CHARGE: this.state.latePaymentMonthlyCharge,
            IS_LATE_PAYMENT_CHARGE_PERCENTAGE: this.state.isLatePaymentChargePercentage,
            TRANSPORT_AND_EXTRA: parseFloat(newTransportAndExtra).toFixed(2),
            GROSS_AMOUNT: this.state.sumValues.grossAmount,
            // NBT: NBT,
            // VAT: VAT,
            DISCOUNT: this.state.sumValues.discount,
            IS_DISCOUNT_PERCENTAGE: this.state.sumValues.isDiscountPercentage,
            // NET_AMOUNT: this.state.sumValues.netAmount,
            NET_AMOUNT: parseFloat(newNetAmount).toFixed(2),
            IS_PROFORMA_INVOICE: this.state.isProformaInvoice,
            REMARK: this.state.remark
        }

        if (this.state.broker != '') {
            invoiceRow.ID_SALES_BROKER = this.state.broker;
        }


        //console.log('sumValues', this.state.sumValues);

        console.log('invoiceRow', invoiceRow);


        //var url = "http://localhost:5006/invoice/createInvoice";
        var url = window.salesServer + "/invoice/createInvoice";
        let body = invoiceRow;

        const request = axios.post(url, body);

        request.then((response) => {

            if (response.data.error || !response.data.success) {
                this.setState({ loading: false, billDate: new Date() });
                if (response.data.message == 'duplicate') {
                    return this.props.alert.error('Duplicate values');
                }
                return this.props.alert.error('Invoice create failed');
            }


            this.props.alert.success('Invoice created. ' + response.data.referenceNo ? response.data.referenceNo : '');
            //console.log('item data recieved', response.data);
            let referenceNo = response.data.referenceNo;
            this.setState({
                refParser: referenceNo
            });

            //var url2 = "http://localhost:5006/invoice/addInvoiceItems";
            var url2 = window.salesServer + "/invoice/addInvoiceItems";
            var body2 = [];

            ////console.log('before loop state selected items', this.state.selectedItems)
            ////console.log('before loop',  body2);
            for (let i = 0; i < this.state.selectedItems.length; i++) {
                ////console.log('in loop body2', body2);
                body2.push(this.state.selectedItems[i].concat([response.data.invoiceId, 1]));
            }

            const invoiceId = response.data.invoiceId;


            //console.log('afterloop state selected items', this.state.selectedItems)
            //console.log('after loop body2', body2);

            const request2 = axios.post(url2, body2);

            request2.then((response) => {

                var customerCode = {
                    customerCode: invoiceRow.CUSTOMER_NAME
                }

                // get customer ledger id using customer code
                axios.post(window.accountServer + '/ledgerAccount/getLedgerAccountIdWhereCustCode', customerCode)
                    .then(customerLedgerResponse => {
                        if (customerLedgerResponse.data.error && !customerLedgerResponse.data.success) {
                            //console.log('customerLedgerResponse Failed', response.data);
                            return this.props.alert.error('Transactions Failed');
                        }

                        var customerLedgerId = customerLedgerResponse.data.resultLedger[0].ID_LEDGER_ACCOUNT;

                        var transactionLedgerHeader = {
                            TANSACTION_TYPE: 'INVOICE',
                            DATE: billDate,
                            REFERENCE_ID: invoiceId,
                            IS_ACTIVE: 1
                        };

                        var transactionLedgerDetails = [
                            [customerLedgerId, null, null, null, invoiceRow.NET_AMOUNT, null, null, 1, null],
                            [CREDIT_SALES_LEDGER_ID, null, null, invoiceRow.NET_AMOUNT, null, null, null, 1, null],
                            [CREDIT_SALES_LEDGER_ID, null, null, null, invoiceRow.VAT, null, null, 1, null],
                            [SALES_TAX_PAYABLE_VAT_LEDGER_ID, null, null, invoiceRow.VAT, null, null, null, 1, null],
                            [CREDIT_SALES_LEDGER_ID, null, null, null, invoiceRow.NBT, null, null, 1, null],
                            [SALES_TAX_PAYABLE_NBT_LEDGER_ID, null, null, invoiceRow.NBT, null, null, null, 1, null],
                        ];

                        const bulkInsertUrl = window.accountServer + "/transactionLedger/bulkInsert";
                        const buldInsertBody = {
                            transactionLedgerHeader: transactionLedgerHeader,
                            transactionLedgerDetails: transactionLedgerDetails
                        };
                        const bulkInsertRequest = axios.post(bulkInsertUrl, buldInsertBody);

                        bulkInsertRequest.then((bulkResponse) => {
                            if (bulkResponse.data.error && !bulkResponse.data.success) {
                                //console.log('Transactions Failed', response.data);
                                this.props.alert.error('Transactions Failed');
                            }
                            this.props.alert.success('Transactions Commited');
                        })
                            .catch(error => {
                                //console.log('Transactions Failed', error);
                                this.props.alert.error('Transactions Failed');
                            });

                    })
                    .catch(error => {
                        //console.log('Transactions Failed Customer Legder Retreive Error', error);
                        this.props.alert.error('Transactions Failed');
                    });

                if (response.data.error && !response.data.success) {
                    return this.props.alert.error('Adding items to invoice failed');
                    //console.log('Adding items to invoice failed', response.data);
                }



                this.props.alert.success('Items added to invoice');
                this.setState({ loading: false, billDate: new Date() });
                this.getInvoiceReport(referenceNo, () => {
                    confirmAlert({
                        title: 'Delivery note?',
                        message: 'Print delivery note?',
                        buttons: [
                            {
                                label: 'Yes',
                                onClick: () => this.handleDNClick()
                            },
                            {
                                label: 'No'
                            }
                        ]
                    })
                });

            })
                .catch((error) => {
                    // Error
                    if (error && typeof error === 'undefined') {
                        //console.log('login axios error block', error);
                    }
                    else if (error) {
                        //console.log('error', error);
                    }
                    this.props.alert.error('Adding items to invoice error');
                    this.setState({ loading: false, billDate: new Date() });

                });

            this.setState({ loading: false, billDate: new Date() });
        })
            .catch((error) => {
                // Error
                if (error && typeof error === 'undefined') {
                    //console.log('login axios error block', error);
                }
                else if (error) {
                    //console.log('error', error);
                }
                this.props.alert.error('Creating invoice error');
                //console.log('axios error block', error);
                this.setState({ loading: false, billDate: new Date() });

            });
    }

    getInvoiceReport(referenceNumber, cb = null) {
        //console.log('getInvoiceReport called', referenceNumber);
        var path = null;
        axios.get(window.reportServer + '/report/get/reportInvoice', {
            params: {
                invoiceNo: referenceNumber
            }
        })
            .then(response => {
                //console.log('getInvoiceReport path', response);
                path = response.data.path;
                path = window.reportServer + "/" + path;
                const url = path;
                window.open(url, '_blank');
                if (cb) {
                    cb();
                }
            }
            )
            .catch((error) => {
                if (error) {
                    //console.log('getInvoiceReport error', error);
                } else {
                    //console.log('getInvoiceReport error');
                }
            });
    }

    getItemAdderState(object) {
        //console.log('items from child', object);
        this.setState({ records: null });
        var items = [];
        for (let i = 0; i < object.records.length; i++) {
            items.push(
                [
                    object.records[i].itemCode,
                    object.records[i].itemName.trim(),
                    object.records[i].isService,
                    object.records[i].discount,
                    object.records[i].isDiscountPercentage ? 1 : 0,
                    object.records[i].unitPrice,
                    object.records[i].quantity,
                    object.records[i].netPrice
                ]
            );
        }
        this.setState({ selectedItems: items });

        var sumValues = {};

        sumValues = {
            netAmount: object.sumValues.netAmount,
            discount: object.sumValues.discount,
            isDiscountPercentage: object.sumValues.isDiscountPercentage,
            // NBT: object.sumValues.NBT,
            // VAT: object.sumValues.VAT,
            grossAmount: object.sumValues.grossAmount,
            transportAndExtra: object.sumValues.transportAndExtra
        };
        this.setState({ sumValues: sumValues });

    }

    getNumberDefyNullZero(value) {
        if (value && !isNaN(value)) {
            ////console.log('getNumberDefyNullZero', value)
            return value;
        } else {
            ////console.log('getNumberDefyNullZero', 0  )
            return 0;
        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(Billing));


// WEBPACK FOOTER //
// ./src/main/content/sales/billing/billing.js